export const policyKeys = {
  all: ['policies'] as const,
  lists: () => [...policyKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...policyKeys.lists(), filters] as const,
  details: () => [...policyKeys.all, 'detail'] as const,
  detail: (id: string) => [...policyKeys.details(), id] as const,
  current: (documentType?: string) => [...policyKeys.all, 'current', documentType] as const,
  acceptances: (id: string, params: Record<string, unknown>) => 
    [...policyKeys.detail(id), 'acceptances', params] as const,
  versions: (id: string) => [...policyKeys.detail(id), 'versions'] as const,
};
